import React from 'react'

export default function Privacy() {
    return (
        <div>
             <h1 style={{textAlign:'center'}}>Privacy</h1> 
        </div>
    )
}
